import React from 'react';

const ToolCard = ({ title, subtitle, onClick, icon }) => {
  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-6 text-left border border-gray-100 hover:border-dark-teal-200 group"
    >
      <div className="flex items-start gap-4">
        {icon && (
          <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-dark-teal-400 to-dark-teal-600 rounded-lg flex items-center justify-center text-white text-xl group-hover:scale-110 transition-transform">
            {icon}
          </div>
        )}
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-dark-teal-600 transition-colors mb-1">
            {title}
          </h3>
          {subtitle && (
            <p className="text-sm text-gray-500">
              {subtitle}
            </p>
          )}
        </div>
        <div className="flex-shrink-0 text-gray-400 group-hover:text-dark-teal-600 group-hover:translate-x-1 transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </button>
  );
};

export default ToolCard;
